import { Component, Directive, EventEmitter, HostListener, Output, forwardRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { environment } from 'src/app/environments/environments.dev';
import { ShowInfoSwal } from 'src/app/helpers/ShowInfoSwal';
import { GenericCrudService } from 'src/app/services/crud/generic-crud.service';
import { catchError, throwError } from 'rxjs';
import Swal from 'sweetalert2';
import { Tag, TipoDocumento } from 'src/app/models/interfaces.model';
import { MdbChipAddEvent } from 'mdb-angular-ui-kit/chips';

@Component({
  selector: 'app-modal-documentos-sgi',
  templateUrl: './modal-documentos-sgi.component.html',
  styleUrls: ['./modal-documentos-sgi.component.css']
})
export class ModalDocumentosSgiComponent {
  @Output() OnGuardarClicked: EventEmitter<any> = new EventEmitter()
  modalTitle: string | null = null
  documentsForm: FormGroup
  active: number = 1
  archivo: File | null = null
  associateDocuments: boolean = false
  logo: string | null = null
  edit: number = 0
  loadingFull = false
  id: number = -1
  insertType: number = -1
  documentName: string | null = null;
  TipoDocumento: TipoDocumento[] = [];
  DetalleTipoDocumento: TipoDocumento[] = [];
  tags: Tag[] = [];
  IdDetalleTipoDocumento = -1
  AllTipoDocumento: { value: any; label: any; NOMBRE_TIPO_DOCUMENTO: any; PARENT: any; }[] | undefined;
  GerenciasAreas: any[] = []
  gerenciasSinRepetir: any[] = []
  areasSeleccionadas: any[] = []
  idDocumentoForEdit: number = -1;
  dataDocumentoForEdit: any[] = []
  URLDOC: string  = '';


  constructor(
    private fb: FormBuilder,
    public modalRefDocuments: MdbModalRef<ModalDocumentosSgiComponent>,
    private crudService: GenericCrudService<any>) {
    this.documentsForm = this.fb.group({});

    /* this.documentsForm = new FormGroup({
       documentName: new FormControl(null, Validators.required),
     });*/
  }



  onEnterPress() {
    return false;
  }

  add(event: MdbChipAddEvent) {
    if (event.value.length > 0 && /\w{2,}/.test(event.value)) {
      this.tags.push({ name: event.value });
      event.input.clear();
    }
  }

  delete(tag: Tag) {
    const index = this.tags.indexOf(tag);

    if (index >= 0) {
      this.tags.splice(index, 1);
    }
  }

  validateSelected(control: FormControl) {
    const selectedOptions = control.value;
    return selectedOptions && selectedOptions.length > 0 ? null : { required: true };
  }
  
  async ngOnInit(): Promise<void> {
    this.loadingFull = true
    const documentName = (this.insertType === 3 ? [Validators.required, Validators.minLength(5)] : []); 
    const tipoDocumentoValidators = ((this.insertType === 2 || this.insertType === 3) ? [Validators.required] : []);
    const tipoDetalleValidators = (this.insertType === 3 ? [Validators.required] : []);
    const documentCodeValidators = (this.insertType === 3 ? [Validators.required] : []);
    const gerenciaValidators = (this.insertType === 3 ? [this.validateSelected] : []);
    const areaValidators = (this.insertType === 3 ? [this.validateSelected] : []);

    const genericValidator = (this.insertType === 3 ? [Validators.required] : []);
    
    this.documentsForm = this.fb.group({
      documentName: ['', documentName],
      TipoDocumento: ['', tipoDocumentoValidators],
      DetalleTipoDocumento: ['', tipoDetalleValidators],
      documentCode: ['', documentCodeValidators],
      documentGerencia: ['', gerenciaValidators],
      documentArea: ['', areaValidators],
      usuarioCreador: ['', genericValidator],
      fechaCreacion: ['', genericValidator],
      usuarioRevision: ['', genericValidator],
      fechaRevision: ['', genericValidator],
      usuarioAprobador: ['', genericValidator],
      fechaAprobacion: ['', genericValidator],
      usuarioPublicador: ['', genericValidator],
      fechaPublicacion: ['', genericValidator],
    });

    const gerenciasSet = new Set();
    if(this.insertType === 3) {
      this.GerenciasAreas.forEach(item => {
        gerenciasSet.add(item.label);
      });
      this.gerenciasSinRepetir = Array.from(gerenciasSet).map(label => {
        const item = this.GerenciasAreas.find(area => area.label === label);
        return { value: item.value, label: item.label };
      });
    }

    try {
      await Promise.all([
        this.getDataDocumentForEdit(),
      ]);
      this.DetalleTipoDocumento = this.DetalleTipoDocumento.filter((item) => item.value != -1);
      this.loadingFull = false;
    } catch (error) {
      console.error('Error al cargar datos:', error);
    }

    this.loadingFull = false
  }

  async getDataDocumentForEdit(): Promise<void> {
    const body = new FormData();
    body.append('action', "SELECT");
    body.append('table_name', "USERS");
    body.append('id_document', this.idDocumentoForEdit.toString());
    return new Promise<void>((resolve, reject) => {
      this.crudService.crud(body, environment.getdataDocumentoForEdit).subscribe((data: any) => {
        if (data && data.status === 1 && data.data) {
          const infoDocument = data.data[0]?.document;
          if (infoDocument) {
            const infoTipoDoc = data.data[0]?.document.DOCUMENT_TYPES.find((type: any) => type.ID === data.data[0]?.document.ID_TIPO_DOCUMENTO)?.PARENT || -1
            const infoDetalleTipoDoc = infoDocument.ID_TIPO_DOCUMENTO
            this.documentsForm.patchValue({
              documentName: infoDocument.NOMBRE_DOCUMENTO,
              documentCode: infoDocument.CODIGO_DOCUMENTO,
              TipoDocumento: infoTipoDoc,
              DetalleTipoDocumento: infoDocument.DOCUMENT_TYPES[0].ID,//infoDocument.DOCUMENT_TYPES,//{...infoDetalleTipoDoc, name_document_type: infoDocument.DOCUMENT_TYPES[0].NOMBRE},
              documentGerencia: infoDocument.GERENCIA_DOCUMENTO,
              documentArea: infoDocument.AREA_DOCUMENTO,
              usuarioCreador: infoDocument.CREACION_USUARIO,
              fechaCreacion: this.dataBaseToDatePicker(infoDocument.CREACION_FECHA),
              usuarioRevision: infoDocument.REVISION_USUARIO,
              fechaRevision: this.dataBaseToDatePicker(infoDocument.REVISION_FECHA),
              usuarioAprobador: infoDocument.APROBACION_USUARIO,
              fechaAprobacion: this.dataBaseToDatePicker(infoDocument.APROBACION_FECHA),
              usuarioPublicador: infoDocument.USUARIO_PUBLICACION,
              fechaPublicacion: this.dataBaseToDatePicker(infoDocument.PUBLICACION_FECHA),
            });

            this.URLDOC = infoDocument.URLDOC
            this.onChangeGerencia(infoDocument.GERENCIA_DOCUMENTO);
            this.onChangeDetalleTipoDocumentoSelected(infoDetalleTipoDoc);
            this.tags = this.convertirStringATags(infoDocument.PALABRAS_CLAVES);
          }
          this.loadingFull = false;
          resolve(); // Resuelve la promesa una vez que se completa la operación
        } else {
          console.error('Error: No se pudo obtener la data de Users.');
          reject('Error al obtener la data de Users'); // Rechaza la promesa en caso de error
        }
      }, error => {
        //this.loadingFull = false; 
        console.error('Error: ', error);
        reject(error); // Rechaza la promesa en caso de error
      });
    });
  }

  onCheckboxChange(event: any) {
    const isChecked = event.target.checked;
    this.active = isChecked ? 1 : 0;

    const selectedAppsControl = this.documentsForm.get('selectedApps');
    if (selectedAppsControl) {
      if (!this.associateDocuments) {
        selectedAppsControl.setValue([]);
      } else {
        selectedAppsControl.setValue(null);
      }
    }
    else
      this.documentsForm.addControl('selectedApps', new FormControl());
  }

  datePickerToDataBase(dateString: string) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  dataBaseToDatePicker(dateString: string) {
    return new Date(dateString);
  }

  InsertOrUpdate(): void {
    let title_ = "¿Realmente desea Crear este tipo de documento para esta empresa?"
    let titleConfirm = "Documento creado exitosamente"
    let documentObj: any;

    if (this.insertType == 3) {
      documentObj = new FormData();
      documentObj.append('action', this.edit == 0 ? "INSERT" : "UPDATE");

      if(this.edit != 0) {
        documentObj.append('id',this.idDocumentoForEdit);
      }

      documentObj.append('table_name', 'DOCUMENTOS');
      documentObj.append('codigo_documento', this.documentsForm.value.documentCode);
      documentObj.append('nombre_documento', this.documentsForm.value.documentName);
      documentObj.append('gerencia_documento', this.documentsForm.value.documentGerencia);
      documentObj.append('area_documento', this.documentsForm.value.documentArea);
      documentObj.append('creacion_usuario', this.documentsForm.value.usuarioCreador);
      documentObj.append('creacion_fecha', this.datePickerToDataBase(this.documentsForm.value.fechaCreacion));
      documentObj.append('revision_usuario', this.documentsForm.value.usuarioRevision);
      documentObj.append('revision_fecha', this.datePickerToDataBase(this.documentsForm.value.fechaRevision));
      documentObj.append('aprobacion_usuario', this.documentsForm.value.usuarioAprobador);
      documentObj.append('aprobacion_fecha', this.datePickerToDataBase(this.documentsForm.value.fechaAprobacion));
      documentObj.append('usuario_publicacion', this.documentsForm.value.usuarioPublicador);
      documentObj.append('publicacion_fecha', this.datePickerToDataBase(this.documentsForm.value.fechaPublicacion));
      documentObj.append('palabras_claves', this.tags.map(tag => tag.name).join(','));
      documentObj.append('id_tipo_documento', this.documentsForm.value.DetalleTipoDocumento != -1 ? this.documentsForm.value.DetalleTipoDocumento : null);
      documentObj.append('active', 1);
      documentObj.append('id_company', localStorage.getItem('IdCompany'));
      documentObj.append('id_app', localStorage.getItem('appId'));
      documentObj.append('id_historical_user', localStorage.getItem('IdUser'));
      documentObj.append( this.edit == 0 ? 'id_user_who_registered' : 'id_user_who_modified', localStorage.getItem('IdUser'));

      if (this.archivo !== null) {
        documentObj.append('urldoc', this.archivo);
      }
    }

    else {
      documentObj = {
        name_document_type: this.documentsForm.value.documentName,
        id_company: localStorage.getItem('IdCompany'),
        id_app: localStorage.getItem('appId'),
        action: 'INSERT'
      };

      if (this.insertType === 2) {
        documentObj.parent = this.documentsForm.value.TipoDocumento;
      }
    }

    Swal.fire({
      title: title_,
      icon: 'warning',
      width: 800,
      customClass: {
        popup: 'custom-swal-popup'
      },
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Procesando...',
          allowOutsideClick: false,
          showCancelButton: false,
          showCloseButton: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();

            let endpoint: string = '';
            if (this.insertType === 1 || this.insertType === 2) {
              endpoint = environment.createOrUpdateDocumentTypes;
            } else if (this.insertType === 3) {
              endpoint = environment.CreateOrUpdateDocumentAndHistorical;
            }
            this.crudService.crud(documentObj, endpoint).toPromise().then(() => {
              //this.getAllApps();
              Swal.fire({
                icon: 'success',
                title: titleConfirm,
                showConfirmButton: false,
                timer: 500
              });
              this.OnGuardarClicked.emit(true);
              this.modalRefDocuments.close();
              this.loadingFull = false;
            }).catch((error) => {
              // Control de error en caso de que falle la eliminación en el servidor
              Swal.fire({
                icon: 'error',
                title: 'Error al eliminar el registro',
                text: error.message,
                allowOutsideClick: false,
              });
            });
          }
        });
      }
    });
    this.OnGuardarClicked.emit(true);
    this.loadingFull = false;
  }

  onFileRemoved(): void {
    this.archivo = null;
  }

  onFileAdded(files: File[]): void {
    this.archivo = files[0];
  }

  onChangeDetalleTipoDocumentoSelected(selectedValue: number) {
    this.IdDetalleTipoDocumento = selectedValue
  }

  onTipoDocumentoSelected(selectedValue: any) {
    // se usa el operador coalescente nulo para proporcionar un valor predeterminado si por alguna razon AllTipoDocumento no está definido
    const allTipoDocumento = this.AllTipoDocumento ?? [];

    if (selectedValue !== null && selectedValue !== undefined) {
      // se filtra la data local basado en el selectedValue
      this.DetalleTipoDocumento = allTipoDocumento
        .filter(item => parseInt(item.PARENT) === parseInt(selectedValue))
        .map(item => ({
          value: item.value,
          label: item.label,
          NOMBRE_TIPO_DOCUMENTO: item.NOMBRE_TIPO_DOCUMENTO
        }));
      //this.DetalleTipoDocumento.unshift({ value: -1, label: 'TODOS', NOMBRE_TIPO_DOCUMENTO: '' });
    } else {
      this.DetalleTipoDocumento = [];
    }
  }

  onChangeGerencia(gerenciaSeleccionada: any) {
    this.areasSeleccionadas = this.GerenciasAreas.filter(item => item.value === gerenciaSeleccionada).map(item => ({ value: item.ID_AREA, label: item.NOMBRE_AREA }));
  }

  // Función para convertir el string en tags
  convertirStringATags(str: string): Tag[] {
    // Dividir el string por las comas
    const palabras = str.split(',');
    // Mapear cada palabra a un objeto Tag
    const tags: Tag[] = palabras.map(palabra => ({ name: palabra.trim() }));
    return tags;
  }
}
